'use client'

import { useIntegrationsModal } from '@/lib/contexts/IntegrationsModalContext'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'
import { AlertCircle } from 'lucide-react'
import { FiLink } from 'react-icons/fi'

export function IntegrationSignInButton() {
  const { openIntegrationsModal } = useIntegrationsModal()

  return (
    <div className="flex w-full gap-x-1">
      <div className="flex grow flex-col gap-y-2 overflow-hidden">
        <div className="mb-5 max-w-[80%] self-start">
          <div
            className="font-hanken-grotesk relative rounded-3xl bg-[#f5f5f7] px-4 py-3 text-[#2D1A47] shadow-sm"
            style={{
              overflowWrap: 'break-word',
              wordBreak: 'break-word',
              fontFamily: 'Hanken Grotesk, sans-serif',
              width: 'fit-content',
              maxWidth: '100%',
              border: '1px solid #e1e1e5',
            }}
          >
            <div className="flex items-center gap-3">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                <AlertCircle className="h-4 w-4 text-blue-600" />
              </div>

              <motion.div
                initial={{ backgroundPosition: '0% 0%' }}
                animate={{ backgroundPosition: '200% 0%' }}
                transition={{
                  duration: 2.5,
                  ease: 'linear',
                  repeat: Infinity,
                }}
                className="rounded-[18px] bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-[length:300%_300%] p-[2px]"
              >
                <motion.button
                  layout
                  className={cn(
                    `inline-flex items-center justify-center gap-2 bg-[#3f3f46]`,
                    `px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-[#2f2f34]`,
                    `focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6b7280] focus-visible:ring-offset-2`,
                    `active:scale-95 disabled:cursor-not-allowed disabled:opacity-50`,
                    `h-full w-full rounded-[16px]`
                  )}
                  onClick={openIntegrationsModal}
                >
                  <motion.div
                    layout
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.2 }}
                    className="flex items-center"
                  >
                    <FiLink className="h-4 w-4" />
                  </motion.div>
                  <motion.span
                    className={'text-base font-medium'}
                    layout
                    initial={{ opacity: 0, y: 2 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    Open Integrations Menu
                  </motion.span>
                </motion.button>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
